import React from "react";
import "./subKeyInfoItem.less";

const SubKeyInfoItem = ({ value, title, showTitle }) => {
   if (title === "-" || title === null || title === "") return null;
   return (
      <div className="gx-product-body-subKeyInfo">
         <p className="p1">
            {showTitle === true && <b>{title}: </b>}
            {value}
         </p>
      </div>
   );
};

export default SubKeyInfoItem;
